import { call, put, all, takeLatest, takeEvery } from "redux-saga/effects";
import * as api from "constants/api";

import {
  PENDING_EMPLOYEE_PERMISSION,
  SG_GET_EMPLOYEE_ORG_PERMISSIONS,
  GET_EMPLOYEE_ORG_PERMISSIONS,
  GET_EMPLOYEE_PERMISSIONS,
  SG_GET_EMPLOYEE_PERMISSIONS,
  DELETE_EMPLOYEE_PERMISSION,
  SG_DELETE_EMPLOYEE_PERMISSION,
  FETCH_EMPLOYEE_PERMISSION,
  SG_FETCH_EMPLOYEE_PERMISSION,
  EDIT_EMPLOYEE_PERMISSION,
  SG_EDIT_EMPLOYEE_PERMISSION,
  ADD_EMPLOYEE_PERMISSION,
  SG_ADD_EMPLOYEE_PERMISSION,
  ADD_EMPLOYEE_LANGUAGE_PERMISSION,
  SG_ADD_EMPLOYEE_LANGUAGE_PERMISSION,
  ALL_ERRORS,
} from "constants/actions";

function* loadmethods(action) {
  yield put({ type: PENDING_EMPLOYEE_PERMISSION });
  // console.log('action.payload', action.payload)
  try {
    const json = yield call(api.GET_EMPLOYEE_PERMISSIONS, action.payload);
    yield put({ type: GET_EMPLOYEE_PERMISSIONS, payload: json.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

export function* methodLoad() {
  yield takeLatest(SG_GET_EMPLOYEE_PERMISSIONS, loadmethods);
}

function* loadOrgmethods(action) {
  yield put({ type: PENDING_EMPLOYEE_PERMISSION });
  // console.log('action.payload', action.payload)
  try {
    const json = yield call(api.GET_EMPLOYEE_PERMISSIONS, action.payload);
    yield put({ type: GET_EMPLOYEE_ORG_PERMISSIONS, payload: json.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

export function* methodOrgLoad() {
  yield takeLatest(SG_GET_EMPLOYEE_ORG_PERMISSIONS, loadOrgmethods);
}

function* fetchmethods(action) {
  yield put({ type: PENDING_EMPLOYEE_PERMISSION });
  try {
    const json = yield call(api.FETCH_EMPLOYEE_PERMISSION, action.payload);
    yield put({ type: FETCH_EMPLOYEE_PERMISSION, payload: json.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

export function* methodFetch() {
  yield takeLatest(SG_FETCH_EMPLOYEE_PERMISSION, fetchmethods);
}

function* updatemethods(action) {
  yield put({ type: PENDING_EMPLOYEE_PERMISSION });
  try {
    const json = yield call(api.EDIT_EMPLOYEE_PERMISSION, action.payload);
    yield put({ type: EDIT_EMPLOYEE_PERMISSION, payload: json.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

export function* methodUpdate() {
  yield takeEvery(SG_EDIT_EMPLOYEE_PERMISSION, updatemethods);
}

function* addmethods(action) {
  yield put({ type: PENDING_EMPLOYEE_PERMISSION });
  try {
    const json = yield call(api.ADD_EMPLOYEE_PERMISSION, action.payload);
    yield put({ type: ADD_EMPLOYEE_PERMISSION, payload: json.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

export function* methodAdd() {
  yield takeLatest(SG_ADD_EMPLOYEE_PERMISSION, addmethods);
}

function* deletemethods(action) {
  yield put({ type: PENDING_EMPLOYEE_PERMISSION });
  try {
    yield call(api.DELETE_EMPLOYEE_PERMISSION, action.payload);
    yield put({ type: DELETE_EMPLOYEE_PERMISSION, payload: action.payload });
  } catch (e) {
    yield put({ type: ALL_ERRORS, payload: e.response });
  }
}

export function* methodDelete() {
  yield takeLatest(SG_DELETE_EMPLOYEE_PERMISSION, deletemethods);
}

export default function* index() {
  yield all([
    methodLoad(),
    methodOrgLoad(),
    methodFetch(),
    methodUpdate(),
    methodAdd(),

    methodDelete(),
  ]);
}
